'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _read_more = require('./global_components/read_more.js');

var _read_more2 = _interopRequireDefault(_read_more);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var Disclosure = function (_React$Component) {
  _inherits(Disclosure, _React$Component);

  function Disclosure(props) {
    _classCallCheck(this, Disclosure);

    var _this = _possibleConstructorReturn(this, (Disclosure.__proto__ || Object.getPrototypeOf(Disclosure)).call(this, props));

    _this.updateAriaAttr = function (reference, isEventTriggered) {
      var textContainer = _this.textEl || {};
      var _this$state = _this.state,
          showAllDisclosure = _this$state.showAllDisclosure,
          alwaysShowFullDisclosure = _this$state.alwaysShowFullDisclosure;

      var inReadLessState = !showAllDisclosure && !alwaysShowFullDisclosure;
      _functional_utility2.default.setAriaAttrsWithTruncatedText(textContainer, _this.ariaText, function () {
        return !inReadLessState;
      }, textContainer.parentElement);
      if (!inReadLessState) {
        (0, _ramda.pathOr)({}, [_this.props.placementId + 'Ref', 'current'], _this).ariaLabel = null;
      }
      var refEle = (0, _ramda.pathOr)({}, [reference, 'current'], _this);
      if (!(0, _functional_utility.isNilOrEmpty)(refEle) && isEventTriggered) {
        refEle.setAttribute('tabindex', '0');
        refEle.focus();setTimeout(function () {
          refEle.removeAttribute('tabindex');
        }, 300);
      }
    };

    _this.onShowMoreClicked = _this.onShowMoreClicked.bind(_this);
    _this.onShowLessClicked = _this.onShowLessClicked.bind(_this);
    _this.getTruncatedDisclosureText = _this.getTruncatedDisclosureText.bind(_this);
    Disclosure.getCssProperty = Disclosure.getCssProperty.bind(_this);
    _this.getTextWidth = _this.getTextWidth.bind(_this);
    _this.renderSingleDisclosure = _this.renderSingleDisclosure.bind(_this);
    _this.renderMultiDisclosure = _this.renderMultiDisclosure.bind(_this);
    _this.readMoreRef = _react2.default.createRef();
    _this.state = {
      showAllDisclosure: (0, _ramda.isNil)(_this.props.shouldAlwaysShowMore) ? false : _this.props.shouldAlwaysShowMore,
      alwaysShowFullDisclosure: (0, _ramda.isNil)(_this.props.alwaysShowFullDisclosure) ? false : _this.props.alwaysShowFullDisclosure,
      disclosureViewWidth: 0,
      containerWidth: 0
    };

    _this[_this.props.placementId + 'Ref'] = _react2.default.createRef();
    return _this;
  }

  _createClass(Disclosure, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!(0, _ramda.isNil)(this[this.props.placementId + 'Ref'])) {
        this.setState({
          disclosureViewWidth: this[this.props.placementId + 'Ref'].clientWidth
        }, function () {
          return _this2.updateAriaAttr(_this2.props.placementId + 'Ref', false);
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this3 = this;

      var getContainerWidth = (0, _ramda.pathOr)(0, ["current", "clientWidth"], this.readMoreRef);
      if (this.state.containerWidth !== getContainerWidth) {
        this.setState({
          containerWidth: getContainerWidth
        }, function () {
          return _this3.updateAriaAttr('readMoreRef', false);
        });
      }
    }
  }, {
    key: 'getTextWidth',


    /**
     * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
     *
     * @param {String} text The text to be rendered.
     * @param {String} placementId The dom element to query to get the css style.
     *
     */
    value: function getTextWidth(text, font, context) {
      context.font = font;
      var metrics = context.measureText(text);
      return metrics.width;
    }
  }, {
    key: 'getTruncatedDisclosureText',
    value: function getTruncatedDisclosureText(summaryDisclosure) {
      var totalWidthInPx = 0;
      var maxPercent = this.getMaxWidthPercent / 100.0;
      var placementIdForTextMeasurement = this.getPlacementIdForTextMeasurement;

      if ((0, _ramda.isNil)(this.state.disclosureViewWidth)) {
        return summaryDisclosure;
      }

      // re-use canvas object for better performance
      if (!this.getTextWidth.canvas) {
        this.getTextWidth.canvas = document.createElement("canvas");
      }
      var canvas = this.getTextWidth.canvas;

      var context = canvas.getContext("2d");
      if ((0, _ramda.isNil)(context)) {
        return summaryDisclosure;
      }

      var el = document.querySelectorAll('[data-testid=' + placementIdForTextMeasurement + ']');

      if ((0, _ramda.isNil)(el[0])) {
        el = document.querySelectorAll('[data-testid=' + placementIdForTextMeasurement + '] .disclaimer');
      }

      if ((0, _ramda.isNil)(el[0])) {
        return summaryDisclosure;
      }

      var fontSize = Math.round(Disclosure.getCssProperty(el[0], 'font-size').replace("px", ""));
      var font = fontSize + "px " + Disclosure.getCssProperty(el[0], 'font-family');

      for (var i = 0; i < summaryDisclosure.length; i++) {
        totalWidthInPx += this.getTextWidth(summaryDisclosure[i], font, context);
        if (totalWidthInPx > this.state.disclosureViewWidth * maxPercent - 20) {
          return summaryDisclosure.substring(0, i) + "&nbsp";
        }
      }

      return summaryDisclosure;
    }
  }, {
    key: 'onShowMoreClicked',
    value: function onShowMoreClicked(event, reference) {
      var _this4 = this;

      event.preventDefault();
      this.setState({ showAllDisclosure: true }, function () {
        return _this4.updateAriaAttr(reference, true);
      });
    }
  }, {
    key: 'onShowLessClicked',
    value: function onShowLessClicked(event, reference) {
      var _this5 = this;

      event.preventDefault();
      this.setState({ showAllDisclosure: false }, function () {
        return _this5.updateAriaAttr(reference, true);
      });
    }
  }, {
    key: 'renderPrintDisclosure',
    value: function renderPrintDisclosure() {
      var disclosureText = this.props.disclosureText;

      return this.props.hideDisclosureinCardForPrintView !== true ? _react2.default.createElement(
        'div',
        { 'data-testid': 'print-disclosures', className: 'print-display', style: { "display": "none" } },
        mapIndexed(function (disclosure, index) {
          return _react2.default.createElement('div', { className: 'print-page-break margin-bottom-15 text-justified', key: index,
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } });
        }, disclosureText.slice(0, disclosureText.length))
      ) : null;
    }
  }, {
    key: 'renderSingleDisclosure',
    value: function renderSingleDisclosure() {
      var _this6 = this;

      var _props = this.props,
          disclosureText = _props.disclosureText,
          shouldAlwaysShowMore = _props.shouldAlwaysShowMore;

      var disclosureTextLines = disclosureText[0];
      if (typeof disclosureTextLines === "string") {
        disclosureTextLines = disclosureTextLines.split("<br\/>");
      }

      var showLessMarkup = _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosureText) } }),
        !shouldAlwaysShowMore && _react2.default.createElement(
          'span',
          null,
          '\xA0',
          _react2.default.createElement(
            'button',
            { id: 'read-less', style: { 'cursor': 'pointer' },
              role: 'button', 'aria-label': 'Read less',
              'aria-expanded': 'true',
              'aria-hidden': 'false',
              onClick: function onClick(e) {
                return _this6.onShowLessClicked(e, 'readMoreRef');
              } },
            _string_utility2.default.renderFormattedLabel("Read less", "pdp-read-less")
          )
        )
      );

      var disclosureAdditionalStyle = (0, _ramda.isNil)(this.props.disclosureAdditionalStyle) ? "" : " " + this.props.disclosureAdditionalStyle;

      return _react2.default.createElement(
        'div',
        { 'data-testid': this.props.placementId,
          id: this.props.placementId,
          className: 'disclosure display-inline-block ' + (this.props.fxFontSize ? this.props.fxFontSize : 'disclaimer') + ' margin-top-15' + (this.props.is25PercentCard ? " padding-horizontal-24 margin-horizontal--30" : "") + disclosureAdditionalStyle,
          style: { width: "100%" },
          ref: this.readMoreRef
        },
        _react2.default.createElement(
          _read_more2.default,
          {
            lines: disclosureTextLines.length,
            id: 'read-more',
            text: _string_utility2.default.renderFormattedLabel("Read more", "pdp-read-more"),
            onShowMore: function onShowMore(e) {
              return _this6.onShowMoreClicked(e, 'readMoreRef');
            },
            className: 'disclosure ' + (this.props.fxFontSize ? this.props.fxFontSize : 'disclaimer') + ' margin-top-0 print-hide',
            containerWidth: this.state.containerWidth,
            displayShowMoreText: !this.state.showAllDisclosure,
            arialabel: this.props.arialabel,
            placementId: this.props.placementId
          },
          !this.state.showAllDisclosure ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosureTextLines[0]) } }) : showLessMarkup
        ),
        this.props.hideDisclosureinCardForPrintView !== true && _react2.default.createElement(
          'div',
          { 'data-testid': 'print-disclosures', className: 'print-display', style: { "display": "none" } },
          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosureText) } })
        )
      );
    }
  }, {
    key: 'renderMultiDisclosure',
    value: function renderMultiDisclosure() {
      var _this7 = this;

      var disclosureText = this.props.disclosureText;
      var _state = this.state,
          showAllDisclosure = _state.showAllDisclosure,
          alwaysShowFullDisclosure = _state.alwaysShowFullDisclosure;

      var disclosureMaxWidth = { "maxWidth": this.getMaxWidthPercent + '%' };

      var disclosureTruncatedText = !showAllDisclosure ? this.getTruncatedDisclosureText(!(0, _functional_utility.isNilOrEmpty)(this.props.disclosureText) && !(0, _functional_utility.isNilOrEmpty)(this.props.disclosureText[0]) ? this.props.disclosureText[0] : "") : null;
      if (!(0, _ramda.isNil)(disclosureTruncatedText)) {
        disclosureTruncatedText = disclosureTruncatedText.replace(/<br\/>/g, '');
      }
      var ariaTextId = 'aria-m-id-' + this.props.placementId;
      var isInReadLessState = !showAllDisclosure && !alwaysShowFullDisclosure;
      var readLessAttrs = isInReadLessState ? {
        'aria-hidden': 'false',
        'aria-labelledby': ariaTextId,
        'aria-describedby': ariaTextId
      } : {};
      return _react2.default.createElement(
        'div',
        _extends({}, readLessAttrs, {
          'data-testid': this.props.placementId,
          className: 'disclosure display-inline-block ' + (this.props.fxFontSize ? this.props.fxFontSize : 'disclaimer') + ' margin-top-15' + (this.props.is25PercentCard ? " padding-horizontal-24 margin-horizontal--30" : ""),
          style: { width: "100%" },
          ref: this[this.props.placementId + 'Ref'],
          role: 'region'
        }),
        isInReadLessState && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement('div', {
            'aria-hidden': 'true',
            ref: function ref(textEl) {
              return _this7.textEl = textEl;
            },
            className: 'display-inline-block margin-bottom-0 text-justified position-relative print-hide overflow-hidden white-space-nowrap overflow-ellipsis',
            style: disclosureMaxWidth,
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosureTruncatedText) } }),
          _react2.default.createElement('span', { id: ariaTextId, ref: function ref(ariaText) {
              return _this7.ariaText = ariaText;
            }, style: { position: 'absolute', left: '-1000vw', height: 0 } }),
          _react2.default.createElement(
            'div',
            { className: 'display-inline-block position-absolute print-hide' },
            '\xA0',
            _react2.default.createElement(
              'button',
              {
                style: { 'cursor': 'pointer' },
                'aria-label': this.props.arialabel,
                role: 'button',
                'aria-expanded': 'false',
                'aria-hidden': 'false',
                onClick: function onClick(e) {
                  return _this7.onShowMoreClicked(e, _this7.props.placementId + 'Ref');
                } },
              _string_utility2.default.renderFormattedLabel("Read more", "pdp-read-more")
            )
          )
        ),
        (showAllDisclosure || alwaysShowFullDisclosure) && mapIndexed(function (disclosure, index) {
          return _react2.default.createElement('div', { className: 'margin-bottom-15 text-justified print-hide', key: index,
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } });
        }, disclosureText.slice(0, disclosureText.length)),
        showAllDisclosure && !alwaysShowFullDisclosure && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { className: 'print-hide', style: { 'cursor': 'pointer' },
              role: 'button',
              'aria-expanded': 'true',
              'aria-hidden': 'false',
              onClick: function onClick(e) {
                return _this7.onShowLessClicked(e, _this7.props.placementId + 'Ref');
              } },
            _string_utility2.default.renderFormattedLabel("Read less", "pdp-read-less")
          )
        ),
        this.renderPrintDisclosure()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var disclosureText = this.props.disclosureText;


      if ((0, _functional_utility.isNilOrEmpty)(disclosureText)) {
        return null;
      }

      if (disclosureText.length === 1) {
        return this.renderSingleDisclosure();
      }

      return this.renderMultiDisclosure();
    }
  }, {
    key: 'getMaxWidthPercent',
    get: function get() {
      var _props2 = this.props,
          breakpoint = _props2.breakpoint,
          disclosureWidthOverride = _props2.disclosureWidthOverride;

      var widthPercentage = 85;

      if (!(0, _ramda.isNil)(disclosureWidthOverride)) {
        widthPercentage = disclosureWidthOverride;
      }

      if (breakpoint < 3) {
        widthPercentage = 78;
      }
      return widthPercentage;
    }
  }, {
    key: 'getPlacementIdForTextMeasurement',
    get: function get() {
      var placementIdForMeasurement = 'pdpBottomAll';
      var el = document.querySelectorAll('[data-testid=pdpBottomAll]');

      if ((0, _ramda.isNil)(el[0])) {
        el = document.querySelectorAll('[data-testid=' + this.props.placementId + ']');
        placementIdForMeasurement = this.props.placementId;
      }

      if ((0, _ramda.isNil)(el[0])) {
        el = document.querySelectorAll('[data-testid="expanded-disclosure-pdp-all"]');
        placementIdForMeasurement = 'expanded-disclosure-pdp-all';
      }

      if ((0, _ramda.isNil)(el[0])) {
        placementIdForMeasurement = this.props.placementId;
      }

      return placementIdForMeasurement;
    }
  }], [{
    key: 'getCssProperty',
    value: function getCssProperty(element, property) {
      return window.getComputedStyle(element).getPropertyValue(property);
    }
  }]);

  return Disclosure;
}(_react2.default.Component);

exports.default = Disclosure;